"use client";

import { useHeaderContext } from "./header.context";
import type { HeaderMobileMenuProps } from "./types/header-mobile-menu.types";
import { headerMobileMenuStyles, headerMobileMenuContentStyles } from "./styles/header-mobile-menu.styles";
import { useEffect, useMemo, useCallback } from "react";

export const HeaderMobileMenu: React.FC<HeaderMobileMenuProps> = (props) => {
  const { children, className, ...rest } = props;

  const { menuOpen, setMenuOpen } = useHeaderContext();

  // React 18: inert must be a string attribute (""), not boolean — its presence activates it.
  const inertProps = useMemo(() => {
    return menuOpen ? {} : { inert: "" };
  }, [menuOpen]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    document.body.classList.toggle("overflow-hidden", menuOpen);
    return () => document.body.classList.remove("overflow-hidden");
  }, [menuOpen]);

  const handleCloseMenu = useCallback(() => {
    setMenuOpen(false);
  }, [setMenuOpen]);

  return (
    <div className={headerMobileMenuStyles({ className, menuOpen })} {...inertProps} {...rest}>
      <div className={headerMobileMenuContentStyles()}>{children}</div>

      <button
        className="fixed left-0 right-0 bottom-0 w-full h-[calc(100dvh-var(--mds-header-menu-top))] top-[var(--mds-header-menu-top)] z-0 bg-transparent"
        aria-hidden="true"
        onClick={handleCloseMenu}
        tabIndex={-1}
      />
    </div>
  );
};

HeaderMobileMenu.displayName = "HeaderMobileMenu";
